import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminGenericProductEdit from "@/pages/admin/AdminGenericProductEdit";

export const Route = createFileRoute("/admin/products/$hub/$id")({
  component: () => (
    <ProtectedRoute>
      <AdminGenericProductEdit />
    </ProtectedRoute>
  ),
});
